import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import SignatureSettings from '../components/SignatureSettings';
export default function extendSettingsPage() {
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    const user = app.session.user;
    if (!user || !user.canEditSignature()) {
      return;
    }
    items.add('signature', m(SignatureSettings, null));
  });
}
flarum.reg.add('fof-signature', 'forum/extenders/extendSettingsPage', extendSettingsPage);